(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2478],{

/***/ 51674:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/pd/[model]/[id]",
      function () {
        return __webpack_require__(10611);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ useAnalyticsEventAfterPageviewEventHasFired; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var _usePageEventsContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43308);


var useAnalyticsEventAfterPageviewEventHasFired = function(event, deps) {
    var pageviewEventHasFired = (0,_usePageEventsContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageEventsContext */ .qN)().pageviewEventHasFired;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (pageviewEventHasFired) event();
    }, [
        pageviewEventHasFired,
        event,
        deps
    ]);
};


/***/ }),

/***/ 10611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _id_; },
  "isVariantId": function() { return /* binding */ isVariantId; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(23842);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(17599);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(59312);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ../node_modules/next/script.js
var script = __webpack_require__(43218);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./utils/encodeProductNameForUri.ts
var encodeProductNameForUri = __webpack_require__(90192);
;// CONCATENATED MODULE: ./utils/encodeProductNameForUriOld.ts
var encodeProductNameForUriOld = function(productName) {
    return encodeURIComponent((productName !== null && productName !== void 0 ? productName : "product-name").toLowerCase().replace(/[',]/g, "")).replace(/%20/g, "-") // Space
    .replace(/%2F/g, "-") // Forward slash
    .replace(/\./g, "-").replace(/!/g, "");
};

;// CONCATENATED MODULE: ./utils/checkIfUriGenerationChanged.ts


var checkIfUriGenerationChanged = function(name) {
    if (!name) {
        return {
            check: false,
            oldUri: "",
            newUri: ""
        };
    }
    var oldUri = encodeProductNameForUriOld(name);
    var newUri = (0,encodeProductNameForUri/* encodeProductNameForUri */.o)(name);
    return {
        check: oldUri !== newUri,
        oldUri: oldUri,
        newUri: newUri
    };
};

// EXTERNAL MODULE: ./utils/breadcrumbRedirects.ts + 1 modules
var breadcrumbRedirects = __webpack_require__(5567);
// EXTERNAL MODULE: ./gql/queries/category.ts
var category = __webpack_require__(4197);
// EXTERNAL MODULE: ./gql/queries/product.ts
var product = __webpack_require__(32952);
// EXTERNAL MODULE: ./__generated__/graphql.ts
var graphql = __webpack_require__(37678);
// EXTERNAL MODULE: ./hooks/usePdp.tsx + 1 modules
var usePdp = __webpack_require__(41316);
// EXTERNAL MODULE: ./hooks/useAuth.tsx
var useAuth = __webpack_require__(72507);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(69771);
// EXTERNAL MODULE: ./hooks/useMiniCart.tsx
var useMiniCart = __webpack_require__(38859);
// EXTERNAL MODULE: ./hooks/usePreferences.tsx
var usePreferences = __webpack_require__(89915);
// EXTERNAL MODULE: ./hooks/useSiteConfig.ts
var useSiteConfig = __webpack_require__(20368);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
// EXTERNAL MODULE: ./ui/components/MiniCart/index.ts + 5 modules
var MiniCart = __webpack_require__(65656);
// EXTERNAL MODULE: ./ui/components/Page.tsx + 1 modules
var Page = __webpack_require__(87150);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ./ui/pages/ProductDetailsPages/index.tsx + 38 modules
var ProductDetailsPages = __webpack_require__(36085);
// EXTERNAL MODULE: ./pages/404.tsx
var _404 = __webpack_require__(15550);
// EXTERNAL MODULE: ./utils/analytics/index.ts + 6 modules
var analytics = __webpack_require__(83168);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(79758);
// EXTERNAL MODULE: ./types/analyticTypes.ts
var analyticTypes = __webpack_require__(90099);
// EXTERNAL MODULE: ./hooks/useAnalyticsEventAfterPageviewEventHasFired.ts
var useAnalyticsEventAfterPageviewEventHasFired = __webpack_require__(9726);
// EXTERNAL MODULE: ./hooks/usePageEventsContext.tsx
var usePageEventsContext = __webpack_require__(43308);
// EXTERNAL MODULE: ./utils/buildProductUrl.ts
var buildProductUrl = __webpack_require__(69377);
// EXTERNAL MODULE: ./utils/locale.ts + 1 modules
var locale = __webpack_require__(79302);
// EXTERNAL MODULE: ./utils/object.ts
var object = __webpack_require__(7676);
// EXTERNAL MODULE: ./utils/products.ts
var products = __webpack_require__(1032);
// EXTERNAL MODULE: ./hooks/useProductHistory.tsx + 2 modules
var useProductHistory = __webpack_require__(17695);
// EXTERNAL MODULE: ./hooks/useInventory.ts
var useInventory = __webpack_require__(55587);
// EXTERNAL MODULE: ./ui/elements/InjectedScript.tsx
var InjectedScript = __webpack_require__(19735);
// EXTERNAL MODULE: ./utils/referrerParametersUtils.ts
var referrerParametersUtils = __webpack_require__(74067);
// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
// EXTERNAL MODULE: ./groq/pages/ProductDetailsPageTemplate.ts
var ProductDetailsPageTemplate = __webpack_require__(55723);
// EXTERNAL MODULE: ./groq/pages/ProductDetailsPage.ts
var ProductDetailsPage = __webpack_require__(22736);
// EXTERNAL MODULE: ./groq/documents/GlobalPromoBannerDocument.ts
var GlobalPromoBannerDocument = __webpack_require__(94735);
// EXTERNAL MODULE: ./groq/documents/SecondGlobalBannerDocument.ts
var SecondGlobalBannerDocument = __webpack_require__(63642);
// EXTERNAL MODULE: ./store/index.ts + 5 modules
var store = __webpack_require__(57023);
// EXTERNAL MODULE: ./ui/components/GiftWithPurchase/index.ts
var GiftWithPurchase = __webpack_require__(28477);
// EXTERNAL MODULE: ./hooks/useFeature.ts
var useFeature = __webpack_require__(53625);
// EXTERNAL MODULE: ./utils/getContentInputQuery.ts
var getContentInputQuery = __webpack_require__(52938);
;// CONCATENATED MODULE: ./ui/content/Emplifi/EndOfPDPWidget.tsx


var EmplifiEndOfPDPWidget = function(param) {
    var sku = param.sku;
    var staticFeatures = (0,useSiteConfig/* useSiteConfig */.N)().staticFeatures;
    if (!staticFeatures.isPNARegion || !sku) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "tt-reviews-summary"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "tt-reviews-list"
            })
        ]
    });
};

// EXTERNAL MODULE: ./ui/content/Emplifi/Script.tsx
var Script = __webpack_require__(24673);
// EXTERNAL MODULE: ./utils/isCrawlerCheck.ts + 1 modules
var isCrawlerCheck = __webpack_require__(22198);
;// CONCATENATED MODULE: ./pages/[country]/[language]/pd/[model]/[id].tsx
/* provided dependency */ var process = __webpack_require__(27061);






















































var VARIANT_ID_MIN_LENGTH = 12; // variant IDs will be 12+ digits long
/** Checks if the length of the given `id` is gte `VARIANT_ID_MIN_LENGTH`. */ var isVariantId = function(id) {
    return id.length >= VARIANT_ID_MIN_LENGTH;
};
var schemaInStock = "http://schema.org/InStock";
var schemaOutOfStock = "http://schema.org/OutOfStock";
var schemaPreOrder = "https://schema.org/PreOrder";
var getAvailability = function(inventory, variation, masterProduct) {
    var ref, ref1;
    // PreOrder
    if (variation === null || variation === void 0 ? void 0 : (ref = variation.displayOutOfStock) === null || ref === void 0 ? void 0 : ref.comingsoon) {
        return schemaPreOrder;
    }
    // Size availability
    if (inventory === null || inventory === void 0 ? void 0 : (ref1 = inventory.data) === null || ref1 === void 0 ? void 0 : ref1.inventory) {
        var ref2;
        return (inventory === null || inventory === void 0 ? void 0 : (ref2 = inventory.data) === null || ref2 === void 0 ? void 0 : ref2.inventory.quantity) !== 0 ? schemaInStock : schemaOutOfStock;
    }
    // Color variant availability
    if (variation === null || variation === void 0 ? void 0 : variation.orderable) {
        return schemaInStock;
    }
    // MasterProduct availability
    if (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.orderable) {
        return schemaInStock;
    }
    return schemaOutOfStock;
};
var ProductDetails = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var setPreferences = (0,usePreferences/* usePreferences */.Gn)().setPreferences;
    var ref6 = (0,useSiteConfig/* useSiteConfig */.N)(), countryCode = ref6.countryCode, language = ref6.language, currency = ref6.currency, host = ref6.host, env = ref6.env, localizeUrlPath = ref6.localizeUrlPath, staticFeatures = ref6.staticFeatures;
    var pixleeProductDiscovery = (0,usePageEventsContext/* usePageEventsContext */.qN)().pixleeProductDiscovery;
    var auth = (0,useAuth/* useAuth */.aC)();
    var hasSentAnalytics = (0,react.useRef)();
    var ref7 = (0,useCart/* useCart */.j)(), addToCart = ref7.addToCart, cart = ref7.cart;
    var isModalOpen = (0,store/* useModalsOpenStore */.wQ)().isModalOpen;
    var ref8 = (0,usePdp/* usePdp */.Y)(), desiredProductId = ref8.desiredProductId, desiredModel = ref8.desiredModel, desiredSize = ref8.desiredSize, desiredSwatch = ref8.desiredSwatch, hasLoaded = ref8.hasLoaded, masterProduct = ref8.masterProduct, variation = ref8.variation, productQuery = ref8.productQuery, lazyProductQuery = ref8.lazyProductQuery, setAddToCartError = ref8.setAddToCartError, setAddToCartReturnCode = ref8.setAddToCartReturnCode, referrerCategoryId = ref8.referrerCategoryId, content = ref8.content, productScore = ref8.productScore, // Content PDP Query Imports
    aboveProductStoryContent = ref8.aboveProductStoryContent, productStoryAdditionalContentSlotContent = ref8.productStoryAdditionalContentSlotContent, belowProductStoryContent = ref8.belowProductStoryContent, belowProductGoogleShoppingContent = ref8.belowProductGoogleShoppingContent, extendedDataContent = ref8.extendedDataContent, // Content PDP Template Query Imports
    aboveProductStoryTemplateContent = ref8.aboveProductStoryTemplateContent, belowProductStoryTemplateContent = ref8.belowProductStoryTemplateContent, belowProductGoogleShoppingTemplateContent = ref8.belowProductGoogleShoppingTemplateContent, stickyAddToCartTemplateContent = ref8.stickyAddToCartTemplateContent, extendedDataTemplateContent = ref8.extendedDataTemplateContent;
    var isGiftWithPurchaseNewDesign = (0,useFeature/* useFeature */.S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    var selectedSwatch = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.variations.find(function(variation) {
        return variation.colorValue === desiredSwatch;
    });
    var sizes = selectedSwatch ? (0,products/* getSizesFromSizeGroups */.hJ)(selectedSwatch === null || selectedSwatch === void 0 ? void 0 : selectedSwatch.sizeGroups) : [];
    var selectedSize = sizes.find(function(item) {
        return item.id === desiredSize;
    });
    var ref9 = (0,_sliced_to_array/* default */.Z)((0,useInventory/* useInventory */.m)(selectedSize === null || selectedSize === void 0 ? void 0 : selectedSize.productId), 1), inventory = ref9[0];
    var previousPlpPath = "";
    if ( true && window.localStorage) {
        var storedPath = localStorage.getItem("productClickedPlpUrl");
        if (storedPath) previousPlpPath = storedPath;
        else previousPlpPath = "non-plp";
    }
    var colors = (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.colors) || [];
    var hasManyColors = colors.length > 1;
    var getVariantSchema = function(masterProduct, currencyCode, masterDescription) {
        var ref;
        return masterProduct === null || masterProduct === void 0 ? void 0 : (ref = masterProduct.variations) === null || ref === void 0 ? void 0 : ref.map(function(param) {
            var masterId = param.masterId, name = param.name, colorValue = param.colorValue, preview = param.preview, colorName = param.colorName, salePrice = param.salePrice, price = param.price, orderable = param.orderable;
            var variantPath = (0,buildProductUrl/* buildProductUrl */.B)(masterId, name, {
                color: colorValue
            });
            return masterId || name ? {
                "@type": "Product",
                name: "".concat(name, " - ").concat(colorName),
                image: preview,
                description: masterDescription,
                color: colorName,
                offers: {
                    "@type": "Offer",
                    url: localizeUrlPath(variantPath, true),
                    priceCurrency: currencyCode,
                    price: salePrice || price,
                    itemCondition: "https://schema.org/NewCondition",
                    availability: orderable ? schemaInStock : schemaOutOfStock
                }
            } : undefined;
        });
    };
    (0,react.useEffect)(function() {
        //For the scenario when user hits a new url in the same browser window
        var handleBeforeUnload = function() {
            (0,referrerParametersUtils/* removeReferrerTypeAndCategory */.JD)();
        };
        //For the scenario when user switch tabs
        var handleVisibilityChange = function() {
            if (document.visibilityState === "hidden") {
                (0,referrerParametersUtils/* removeReferrerTypeAndCategory */.JD)();
            }
        };
        //For the scenario when user goes back or forward using browser arrows
        var handlePopState = function() {
            (0,referrerParametersUtils/* removeReferrerTypeAndCategory */.JD)();
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        window.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("popstate", handlePopState);
        return function() {
            localStorage.removeItem("productClickedPlpUrl");
            (0,referrerParametersUtils/* removeReferrerTypeAndCategory */.JD)();
            window.removeEventListener("beforeunload", handleBeforeUnload);
            window.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("popstate", handlePopState);
        };
    }, []);
    var ref10 = (0,useMiniCart/* useMiniCart */.lm)(), isMiniCartVisible = ref10.isMiniCartVisible, closeMiniCart = ref10.closeMiniCart;
    (0,useAnalyticsEventAfterPageviewEventHasFired/* useAnalyticsEventAfterPageviewEventHasFired */.T)(function() {
        var ref;
        var ref1;
        var sizes = (0,products/* getSizesFromSizeGroups */.hJ)((ref1 = variation === null || variation === void 0 ? void 0 : variation.sizeGroups) !== null && ref1 !== void 0 ? ref1 : []);
        var ref2, ref3;
        var itemId = (ref3 = (ref2 = (ref = sizes === null || sizes === void 0 ? void 0 : sizes.find(function(s) {
            return s.id === desiredSize;
        })) === null || ref === void 0 ? void 0 : ref.productId) !== null && ref2 !== void 0 ? ref2 : variation === null || variation === void 0 ? void 0 : variation.id) !== null && ref3 !== void 0 ? ref3 : masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id;
        if (productQuery.fetching || !masterProduct || hasSentAnalytics.current === itemId) return;
        if (productQuery.data && variation && masterProduct) {
            var ref4;
            var product = (ref4 = productQuery.data) === null || ref4 === void 0 ? void 0 : ref4.product;
            var ref5;
            var productDiscovery = (ref5 = window.localStorage.getItem(constants/* REFERRER_TYPE */.cj)) !== null && ref5 !== void 0 ? ref5 : pixleeProductDiscovery ? "pixlee" : "";
            if (pixleeProductDiscovery) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PROMOTION_CLICK */._q.PROMOTION_CLICK, {
                    ecommerce: {
                        promoClick: {
                            promotions: [
                                {
                                    id: product === null || product === void 0 ? void 0 : product.id,
                                    name: "How To Wear It",
                                    creative: "pixlee",
                                    position: "1",
                                    cta: "Buy Now"
                                }, 
                            ]
                        }
                    }
                });
            }
            if (variation) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.PRODUCT_VIEWED */._q.PRODUCT_VIEWED, {
                    currencyCode: currency.code,
                    ecommerce: {
                        detail: {
                            actionField: {
                                list: router.query.search ? "internal search" : previousPlpPath
                            },
                            products: [
                                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,analytics/* transformProductToAnalyticsProduct */.vA)({
                                    categoryId: referrerCategoryId,
                                    desiredSize: desiredSize,
                                    includeExtraAnalyticsDimensions: true,
                                    product: product,
                                    variant: variation
                                })), (0,_define_property/* default */.Z)({}, analyticTypes/* Dimensions.d100 */.Db.d100, productDiscovery)), 
                            ]
                        }
                    }
                });
                hasSentAnalytics.current = itemId;
            }
            var isElevated = (content === null || content === void 0 ? void 0 : content.aboveProductStory) !== undefined;
            if (isElevated) {
                (0,analytics/* event */.B)(analytics/* AnalyticsEvents.ELEVATED_PDP_IMPRESSION */._q.ELEVATED_PDP_IMPRESSION);
            }
        }
    }, [
        desiredProductId,
        productQuery,
        variation,
        masterProduct,
        desiredSize
    ]);
    // On mount, start session, add product to last viewed product preferences
    (0,react.useEffect)(function() {
        if (desiredSwatch) {
            var currentItem = {
                id: desiredProductId,
                name: desiredModel,
                swatch: desiredSwatch,
                size: desiredSize,
                country: countryCode
            };
            window.sessionStorage.setItem("in-session", "true");
            setPreferences(function(curr) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, curr), {
                    "last-viewed-product": currentItem
                });
            });
        }
        return function() {
            closeMiniCart();
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    (0,react.useEffect)(function() {
        if (desiredSwatch && (variation === null || variation === void 0 ? void 0 : variation.name)) {
            var currentItem = {
                id: desiredProductId,
                name: variation.name,
                swatch: desiredSwatch
            };
            setPreferences(function(curr) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, curr), {
                    "last-ga4-item": currentItem
                });
            });
        }
    }, [
        desiredProductId,
        desiredSwatch,
        variation === null || variation === void 0 ? void 0 : variation.name
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    var pushItemToProductHistory = (0,useProductHistory/* useProductHistory */.Xd)().pushItemToProductHistory;
    (0,react.useEffect)(function() {
        if (desiredProductId && desiredSwatch) pushItemToProductHistory({
            id: desiredProductId,
            color: desiredSwatch
        });
    }, [
        desiredProductId,
        desiredSwatch
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // Reset cart error when changing size/color.
    (0,react.useEffect)(function() {
        setAddToCartError(undefined);
        setAddToCartReturnCode(undefined);
    }, [
        desiredSize,
        desiredSwatch
    ]); // eslint-disable-line react-hooks/exhaustive-deps
    // If swatch or size from URL are invalid, remove from query and update router.
    // If variation isn't set you could end up in an infinite loop
    // make sure variation is always checked here
    if (!constants/* isServer */.sk && (!productQuery.fetching || productQuery.fetching && productQuery.stale) && !lazyProductQuery.fetching && variation) {
        var ref11;
        var sizes1 = (ref11 = (0,products/* getSizesFromSizeGroups */.hJ)(variation.sizeGroups)) !== null && ref11 !== void 0 ? ref11 : [];
        if (router.query.swatch && router.query.swatch !== variation.colorValue) {
            router.replace({
                query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                    swatch: variation.colorValue
                })
            });
        }
        if (desiredSize) {
            var size = sizes1.find(function(x) {
                return x.id === desiredSize;
            });
            // if requested size doesn't exists remove it from the query
            if (!size) {
                var _query = router.query, _ = _query.size, query = (0,_object_without_properties/* default */.Z)(_query, [
                    "size"
                ]);
                router.replace({
                    query: query
                });
            }
        } else {
            if (sizes1.length === 1) {
                router.replace({
                    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, router.query), {
                        size: sizes1[0].id
                    })
                });
            }
        }
    }
    (0,react.useEffect)(function() {
        if (masterProduct && variation) {
            var ref;
            var fitAnalytics = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,analytics/* getCommonFitAnalyticsData */.RW)(language, countryCode, currency.code, auth.customerId, ((ref = window.fitAnalytics) === null || ref === void 0 ? void 0 : ref.sessionId) || ""), (0,analytics/* getPDPFitAnalyticsData */.Cv)(masterProduct, variation, variation.colorValue)), {
                operations: {
                    addToCart: function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(productId, desiredSize) {
                            var quantity, variation, sizes, findCorrectSize, currentUrl, _tmp, _tmp1;
                            var _arguments = arguments;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        quantity = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 1;
                                        variation = masterProduct.variations.find(function(product) {
                                            return product.styleNumber === productId;
                                        });
                                        if (!variation) return [
                                            3,
                                            2
                                        ];
                                        sizes = (0,products/* getSizesFromSizeGroups */.hJ)(variation.sizeGroups);
                                        findCorrectSize = sizes.find(function(size) {
                                            return size.label === desiredSize;
                                        });
                                        currentUrl = router.asPath;
                                        _tmp = {};
                                        _tmp1 = {};
                                        return [
                                            4,
                                            addToCart((_tmp.swatch = variation.colorValue, _tmp.size = findCorrectSize === null || findCorrectSize === void 0 ? void 0 : findCorrectSize.id, _tmp.quantity = quantity, _tmp.productId = (findCorrectSize === null || findCorrectSize === void 0 ? void 0 : findCorrectSize.productId) || "", _tmp.productCustomization = undefined, _tmp.masterId = masterProduct.id, _tmp), _tmp1, true, currentUrl)
                                        ];
                                    case 1:
                                        _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(productId, desiredSize) {
                            return _ref.apply(this, arguments);
                        };
                    }()
                }
            });
            window.fitAnalytics = fitAnalytics;
        }
    }, [
        masterProduct,
        variation,
        language,
        countryCode,
        currency.code,
        auth.customerId,
        desiredSwatch,
        desiredSize,
        addToCart,
        router.asPath, 
    ]);
    var shouldShowNotFoundPage = hasLoaded && !(masterProduct && variation);
    if (shouldShowNotFoundPage) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(_404["default"], {
            message: t("productCouldNotBeFound")
        });
    }
    // only enable fitanalytics in CSR when configured on non local envs
    var shouldEnableFitAnalytics = !constants/* isServer */.sk && location.hostname.indexOf("localhost") === -1 && env.fitAnalyticsPdpUrl;
    var combinedProductStories = (0,_to_consumable_array/* default */.Z)((content === null || content === void 0 ? void 0 : content.aboveProductStory) || []).concat((0,_to_consumable_array/* default */.Z)((content === null || content === void 0 ? void 0 : content.belowProductStory) || []));
    var hreflangs = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, Object.fromEntries(Object.entries((masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productNameTranslated) || {}).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return [
            key,
            String((0,buildProductUrl/* buildProductUrl */.B)((masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) || "", value || "")), 
        ];
    }).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), _ = _param[0], value = _param[1];
        return value !== undefined;
    }))), (0,_define_property/* default */.Z)({}, language, (0,buildProductUrl/* buildProductUrl */.B)((masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) || "", (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name) || "")));
    var isElevatedPdp = combinedProductStories.some(function(item) {
        if ((item === null || item === void 0 ? void 0 : item.component) && "_type" in item.component) {
            var ref;
            var componentType = item === null || item === void 0 ? void 0 : (ref = item.component) === null || ref === void 0 ? void 0 : ref._type;
            return componentType && constants/* ELEVATED_PDP_TYPES.includes */.Qn.includes(componentType);
        }
    });
    var productId = (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id) || (variation === null || variation === void 0 ? void 0 : variation.masterId) || "";
    var productName = (productQuery === null || productQuery === void 0 ? void 0 : (ref = productQuery.data) === null || ref === void 0 ? void 0 : (ref1 = ref.product) === null || ref1 === void 0 ? void 0 : ref1.name) || (variation === null || variation === void 0 ? void 0 : variation.name) || (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name) || "";
    var ref12;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Page/* Page */.T, {
        query: [
            (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, productQuery), {
                fetching: productQuery.fetching && !productQuery.data || productQuery.fetching && desiredProductId !== ((ref2 = productQuery.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.product) === null || ref3 === void 0 ? void 0 : ref3.id)
            }),
            // Content PDP Queries Data
            (0,_object_spread/* default */.Z)({}, aboveProductStoryContent),
            (0,_object_spread/* default */.Z)({}, productStoryAdditionalContentSlotContent),
            (0,_object_spread/* default */.Z)({}, belowProductStoryContent),
            (0,_object_spread/* default */.Z)({}, belowProductGoogleShoppingContent),
            (0,_object_spread/* default */.Z)({}, extendedDataContent),
            // Content PDP Template Queries Data
            (0,_object_spread/* default */.Z)({}, aboveProductStoryTemplateContent),
            (0,_object_spread/* default */.Z)({}, belowProductStoryTemplateContent),
            (0,_object_spread/* default */.Z)({}, belowProductGoogleShoppingTemplateContent),
            (0,_object_spread/* default */.Z)({}, stickyAddToCartTemplateContent),
            (0,_object_spread/* default */.Z)({}, extendedDataTemplateContent), 
        ],
        emarsysData: {
            skipTracking: false
        },
        bloomreachData: {
            prod_id: "".concat(masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id, "_").concat(variation === null || variation === void 0 ? void 0 : variation.colorValue),
            prod_name: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name,
            sku: (variation === null || variation === void 0 ? void 0 : variation.ean) || undefined
        },
        pageViewPageType: isElevatedPdp ? "elevated pdp" : "pdp",
        children: [
            shouldEnableFitAnalytics && /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: env.fitAnalyticsPdpUrl,
                strategy: "afterInteractive"
            }),
            staticFeatures.isPNARegion && (variation === null || variation === void 0 ? void 0 : variation.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Script/* EmplifiScript */.l, {
                sku: (variation === null || variation === void 0 ? void 0 : variation.id) || "",
                pageId: "pdp-page"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: t("pageTitleReduced", {
                    title: (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name) || decodeURIComponent(desiredModel).replace(/-/g, " ")
                }),
                openGraphType: "product",
                description: (ref12 = masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description) !== null && ref12 !== void 0 ? ref12 : "",
                canonical: (0,buildProductUrl/* buildProductUrl */.B)(productId, productName),
                hreflangs: (masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.productNameTranslated) ? hreflangs : undefined,
                openGraphImageUrl: variation === null || variation === void 0 ? void 0 : variation.preview,
                twitterImageUrl: variation === null || variation === void 0 ? void 0 : variation.preview
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: JSON.stringify((0,object/* avoidEmptyProperties */._h)({
                    "@context": "http://schema.org",
                    "@type": "Product",
                    name: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name,
                    sku: variation === null || variation === void 0 ? void 0 : variation.ean,
                    color: variation === null || variation === void 0 ? void 0 : variation.colorName,
                    description: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description,
                    model: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
                    brand: {
                        "@type": "Brand",
                        name: "PUMA"
                    },
                    logo: "https://".concat(host, "/assets/logo-puma-black.png"),
                    image: variation === null || variation === void 0 ? void 0 : variation.images.map(function(x) {
                        return x.href;
                    }),
                    offers: {
                        "@type": "Offer",
                        price: (variation === null || variation === void 0 ? void 0 : variation.salePrice) || (variation === null || variation === void 0 ? void 0 : variation.price),
                        priceCurrency: currency.code,
                        availability: getAvailability(inventory, variation, masterProduct),
                        availabilityStarts: (variation === null || variation === void 0 ? void 0 : (ref4 = variation.displayOutOfStock) === null || ref4 === void 0 ? void 0 : ref4.validTo) || undefined,
                        priceValidUntil: variation === null || variation === void 0 ? void 0 : variation.validUntil,
                        priceSpecification: (variation === null || variation === void 0 ? void 0 : variation.salePrice) !== (variation === null || variation === void 0 ? void 0 : variation.price) ? {
                            "@type": "UnitPriceSpecification",
                            priceType: "https://schema.org/StrikethroughPrice",
                            price: variation === null || variation === void 0 ? void 0 : variation.price,
                            priceCurrency: currency.code
                        } : undefined,
                        url: !constants/* isServer */.sk ? window.location.href : router.asPath,
                        seller: {
                            "@type": "Corporation",
                            name: "PUMA"
                        }
                    },
                    aggregateRating: productScore && Number(productScore.amount) > 0 ? {
                        "@type": "AggregateRating",
                        ratingValue: productScore.rating,
                        reviewCount: productScore.amount,
                        bestRating: 5,
                        worstRating: 1
                    } : undefined,
                    review: ((productScore === null || productScore === void 0 ? void 0 : (ref5 = productScore.reviews) === null || ref5 === void 0 ? void 0 : ref5.nodes) || []).map(function(review) {
                        return {
                            "@type": "Review",
                            author: {
                                "@type": "Person",
                                name: review.nickname || "anonymous"
                            },
                            datePublished: review.date,
                            name: review.title,
                            reviewBody: review.text,
                            reviewRating: {
                                "@type": "Rating",
                                ratingValue: review.rating,
                                bestRating: 5,
                                worstRating: 1
                            }
                        };
                    })
                }))
            }),
            hasManyColors && /*#__PURE__*/ (0,jsx_runtime.jsx)(InjectedScript/* InjectedScript */.D, {
                type: "application/ld+json",
                script: JSON.stringify((0,object/* avoidEmptyProperties */._h)({
                    "@context": "http://schema.org",
                    "@type": "ProductGroup",
                    name: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.name,
                    sku: variation === null || variation === void 0 ? void 0 : variation.ean,
                    url: "https://".concat(host).concat(router.asPath.split("?")[0]),
                    description: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description,
                    brand: {
                        "@type": "Brand",
                        name: "PUMA"
                    },
                    productGroupID: masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id,
                    variesBy: "https://schema.org/color",
                    hasVariant: getVariantSchema(masterProduct, currency.code, masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.description)
                }))
            }),
            variation && masterProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetailsPages/* ProductDetailsPage */.nz, {}),
            isMiniCartVisible && /*#__PURE__*/ (0,jsx_runtime.jsx)(MiniCart/* MiniCart */.pp, {}, masterProduct === null || masterProduct === void 0 ? void 0 : masterProduct.id),
            isModalOpen("GWPModal") ? isGiftWithPurchaseNewDesign ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftWithPurchase/* GWPNewDesign.Modal */.kq.Modal, {
                cart: cart
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(GiftWithPurchase/* GWPOldDesign.Modal */.fy.Modal, {
                cart: cart
            }) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(EmplifiEndOfPDPWidget, {
                sku: (variation === null || variation === void 0 ? void 0 : variation.id) || ""
            })
        ]
    });
};
var Pdp = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(usePdp/* PdpProvider */.R, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductDetails, (0,_object_spread/* default */.Z)({}, props))
    });
};
if (constants/* isServer */.sk) {
    Pdp.getInitialProps = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
            var ref, ref1, ref2, ref3, id, req, host, namespace, isCrawler, _tmp, queriesParellelizationList, ref4, ref5, ref6, ref7, data, _tmp1, _tmp2, ref8, masterId, name, colorValue, size, queryString, additionalParams, _tmp3, variantPath, _tmp4, localePrefix, relativePath, host1, protocol, fullPath, redirectUrl, _tmp5, _tmp6, pdpQuery, _tmp7, aboveProductStoryTemplateContent, _tmp8, belowProductStoryTemplateContent, _tmp9, belowProductGoogleShoppingTemplateContent, _tmp10, stickyAddToCartTemplateContent, _tmp11, extendedDataTemplateContent, _tmp12, aboveProductStoryContent, _tmp13, productStoryAdditionalContentSlotContent, _tmp14, belowProductStoryContent, _tmp15, belowProductGoogleShoppingContent, _tmp16, extendedDataContent, _tmp17, globalPromoBannerQuery, _tmp18, secondGlobalBannerQuery, _tmp19, mainFooterQuery, _tmp20, pixleeConfigQuery, _tmp21, productScoreQuery, _tmp22, userGeneratedContent, _tmp23, data1, _tmp24, ref9, categoryByIdQuery, _tmp25, categoryResult, categoryById, _queriesParellelizationList, breadcrumbLinks, _tmp26, redirectPromises, name1, currentUrl, ref10, check, oldUri, newUri, baseUrl, fullUrl, ref11, ref12, ref13, ref14, params, newProductUrl, localePrefix1, relativePath1, host2, protocol1, fullPath1, redirectUrl1, _tmp27, _tmp28;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        id = context.query.id;
                        req = context.req;
                        host = req.headers.host;
                        namespace = process.env.NAMESPACE;
                        _tmp = {};
                        isCrawler = (0,isCrawlerCheck/* isCrawlerCheck */.c)((_tmp.host = host, _tmp.namespace = namespace, _tmp.req = req, _tmp));
                        queriesParellelizationList = [];
                        if (!isVariantId(id)) return [
                            3,
                            2
                        ];
                        _tmp1 = {};
                        return [
                            4,
                            context.urqlClient.query(product/* VARIANT_QUERY */.YE, (_tmp1.id = id, _tmp1)).toPromise()
                        ];
                    case 1:
                        data = _state.sent().data;
                        _tmp2 = {};
                        if (!(data === null || data === void 0 ? void 0 : data.variant)) {
                            if (context.res) context.res.statusCode = 404;
                            return [
                                2,
                                _tmp2
                            ]; // Fall through to allow client-side 404 page to render
                        }
                        ref8 = data === null || data === void 0 ? void 0 : data.variant, masterId = ref8.masterId, name = ref8.name, colorValue = ref8.colorValue, size = ref8.size;
                        queryString = (ref4 = context.asPath) === null || ref4 === void 0 ? void 0 : ref4.split("?")[1];
                        _tmp3 = {};
                        additionalParams = queryString === null || queryString === void 0 ? void 0 : queryString.split("&").reduce(function(acc, entry) {
                            var ref = (0,_sliced_to_array/* default */.Z)(entry.split("="), 2), key = ref[0], value = ref[1];
                            acc[key] = value;
                            return acc;
                        }, _tmp3);
                        _tmp4 = {};
                        variantPath = (0,buildProductUrl/* buildProductUrl */.B)(masterId, name, (0,_object_spread/* default */.Z)((_tmp4.color = colorValue, _tmp4.size = size.value, _tmp4), additionalParams));
                        localePrefix = (0,locale/* getUrlFromLocale */.bH)((ref5 = context.req) === null || ref5 === void 0 ? void 0 : ref5.headers.locale);
                        relativePath = "".concat(localePrefix).concat(variantPath);
                        host1 = (ref6 = context.req) === null || ref6 === void 0 ? void 0 : ref6.headers.host;
                        protocol = (host1 === null || host1 === void 0 ? void 0 : host1.includes("localhost")) ? "http" : "https";
                        fullPath = "".concat(protocol, "://").concat(host1).concat(relativePath);
                        redirectUrl = host1 ? fullPath : relativePath;
                        _tmp5 = {};
                        // eslint-disable-next-line no-console
                        console.warn("Redirect with Variant ID", (_tmp5.from = id, _tmp5.to = variantPath, _tmp5));
                        _tmp6 = {};
                        return [
                            2,
                            (ref7 = context.res) === null || ref7 === void 0 ? void 0 : ref7.writeHead(301, (_tmp6.Location = redirectUrl, _tmp6)).end()
                        ];
                    case 2:
                        _tmp7 = {};
                        pdpQuery = context.urqlClient.query(graphql/* PdpDocument */._y, (_tmp7.id = id, _tmp7));
                        _tmp8 = {};
                        aboveProductStoryTemplateContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("AboveProductStory_PDPTemplate"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp8.query = ProductDetailsPageTemplate/* AboveProductStory_PDPTemplateQuery */.gx, _tmp8.context = context, _tmp8)));
                        _tmp9 = {};
                        belowProductStoryTemplateContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("BelowProductStory_PDPTemplate"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp9.query = ProductDetailsPageTemplate/* BelowProductStory_PDPTemplateQuery */.Iz, _tmp9.context = context, _tmp9)));
                        _tmp10 = {};
                        belowProductGoogleShoppingTemplateContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("BelowProductGoogleShopping_PDPTemplate"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp10.query = ProductDetailsPageTemplate/* BelowProductGoogleShopping_PDPTemplateQuery */.kN, _tmp10.context = context, _tmp10)));
                        _tmp11 = {};
                        stickyAddToCartTemplateContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("StickyAddToCart_PDPTemplate"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp11.query = ProductDetailsPageTemplate/* StickyAddToCart_PDPTemplateQuery */.MH, _tmp11.context = context, _tmp11)));
                        _tmp12 = {};
                        extendedDataTemplateContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("ExtendedData_PDPTemplate"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp12.query = ProductDetailsPageTemplate/* ExtendedData_PDPTemplateQuery */.PZ, _tmp12.context = context, _tmp12)));
                        _tmp13 = {};
                        _tmp14 = {};
                        _tmp15 = {};
                        _tmp16 = {};
                        _tmp17 = {};
                        if (isCrawler) {
                            aboveProductStoryContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("PDP_AboveProductStory"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp13.query = ProductDetailsPage/* AboveProductStory_PDPContentQuery */.Pl, _tmp13.context = context, _tmp13.params = {
                                productId: id
                            }, _tmp13)));
                            productStoryAdditionalContentSlotContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("PDP_ProductStoryAdditionalContentSlot"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp14.query = ProductDetailsPage/* ProductStoryAdditionalContentSlot_PDPContentQuery */.lJ, _tmp14.context = context, _tmp14.params = {
                                productId: id
                            }, _tmp14)));
                            belowProductStoryContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("PDP_BelowProductStory"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp15.query = ProductDetailsPage/* BelowProductStory_PDPContentQuery */.v1, _tmp15.context = context, _tmp15.params = {
                                productId: id
                            }, _tmp15)));
                            belowProductGoogleShoppingContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("PDP_BelowProductGoogleShopping"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp16.query = ProductDetailsPage/* BelowProductGoogleShopping_PDPContentQuery */.NK, _tmp16.context = context, _tmp16.params = {
                                productId: id
                            }, _tmp16)));
                            extendedDataContent = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("PDP_ExtendedData"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp17.query = ProductDetailsPage/* ExtendedData_PDPContentQuery */.lD, _tmp17.context = context, _tmp17.params = {
                                productId: id
                            }, _tmp17)));
                            queriesParellelizationList.push(aboveProductStoryContent, productStoryAdditionalContentSlotContent, belowProductStoryContent, belowProductGoogleShoppingContent, extendedDataContent);
                        }
                        _tmp18 = {};
                        globalPromoBannerQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("GlobalPromoBanner"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp18.query = GlobalPromoBannerDocument/* GlobalPromoBannerDocument */.$, _tmp18.context = context, _tmp18)));
                        _tmp19 = {};
                        secondGlobalBannerQuery = context.urqlClient.query((0,useGroqQuery/* CONTENT_QUERY */.lK)("SecondGlobalBanner"), (0,getContentInputQuery/* getContentInputQuery */._)((_tmp19.query = SecondGlobalBannerDocument/* SecondGlobalBannerDocument */.B, _tmp19.context = context, _tmp19)));
                        _tmp20 = {};
                        mainFooterQuery = context.urqlClient.query(graphql/* MainFooterDocument */.Sd9, (_tmp20.isDraft = context.query.draft, _tmp20));
                        _tmp21 = {};
                        pixleeConfigQuery = context.urqlClient.query(graphql/* PixleeConfigDocument */.UMO, _tmp21);
                        _tmp22 = {};
                        productScoreQuery = context.urqlClient.query(graphql/* ProductScoreDocument */.P92, (_tmp22.id = id, _tmp22.includeReviews = true, _tmp22));
                        _tmp23 = {};
                        userGeneratedContent = context.urqlClient.query(graphql/* UserGeneratedContentDocument */.pVf, (_tmp23.productId = id, _tmp23));
                        // Parallelize the following queries on SSR
                        queriesParellelizationList.push(globalPromoBannerQuery, secondGlobalBannerQuery, mainFooterQuery, pixleeConfigQuery, productScoreQuery, userGeneratedContent, aboveProductStoryTemplateContent, belowProductStoryTemplateContent, belowProductGoogleShoppingTemplateContent, stickyAddToCartTemplateContent, extendedDataTemplateContent);
                        return [
                            4,
                            pdpQuery.toPromise()
                        ];
                    case 3:
                        data1 = _state.sent().data;
                        _tmp24 = {};
                        if (!(data1 === null || data1 === void 0 ? void 0 : data1.product)) {
                            if (context.res) context.res.statusCode = 404;
                            return [
                                2,
                                _tmp24
                            ]; // Fall through to allow client-side 404 page to render
                        }
                        if (!(data1.product && data1.product.primaryCategoryId)) return [
                            3,
                            5
                        ];
                        _tmp25 = {};
                        categoryByIdQuery = context.urqlClient.query(category/* CATEGORY_BY_ID_QUERY */.M, (_tmp25.id = data1.product.primaryCategoryId, _tmp25));
                        return [
                            4,
                            categoryByIdQuery.toPromise()
                        ];
                    case 4:
                        categoryResult = _state.sent();
                        categoryById = (ref9 = categoryResult.data) === null || ref9 === void 0 ? void 0 : ref9.categoryById;
                        _tmp26 = {};
                        if (categoryById) {
                            ;
                            breadcrumbLinks = (0,breadcrumbRedirects/* createProductBreadcrumbLinks */.A2)((_tmp26.categoryById = categoryById, _tmp26.productName = data1.product.name, _tmp26.productLink = "pd/".concat(context.query.model, "/").concat(context.query.id), _tmp26));
                            redirectPromises = (0,breadcrumbRedirects/* fetchBreadcrumbRedirectPromises */.VD)(context.urqlClient, (0,_to_consumable_array/* default */.Z)(breadcrumbLinks));
                            (_queriesParellelizationList = queriesParellelizationList).push.apply(_queriesParellelizationList, (0,_to_consumable_array/* default */.Z)(redirectPromises));
                        }
                        _state.label = 5;
                    case 5:
                        return [
                            4,
                            Promise.all(queriesParellelizationList)
                        ];
                    case 6:
                        _state.sent();
                        name1 = data1.product.name || "";
                        currentUrl = ((ref = context.req) === null || ref === void 0 ? void 0 : ref.url) || "";
                        ref10 = checkIfUriGenerationChanged(name1), check = ref10.check, oldUri = ref10.oldUri, newUri = ref10.newUri;
                        baseUrl = "".concat(((ref1 = context.req) === null || ref1 === void 0 ? void 0 : ref1.headers["x-forwarded-proto"]) || "http", "://").concat((ref2 = context.req) === null || ref2 === void 0 ? void 0 : ref2.headers.host);
                        fullUrl = new URL(currentUrl, baseUrl);
                        _tmp27 = {};
                        if (check && ((ref3 = context.asPath) === null || ref3 === void 0 ? void 0 : ref3.includes(oldUri)) && !(newUri === null || newUri === void 0 ? void 0 : newUri.includes(oldUri))) {
                            ;
                            params = Object.fromEntries(new URLSearchParams(fullUrl.search));
                            newProductUrl = (0,buildProductUrl/* buildProductUrl */.B)(data1.product.id, name1, params);
                            localePrefix1 = (0,locale/* getUrlFromLocale */.bH)((ref11 = context.req) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.headers) === null || ref12 === void 0 ? void 0 : ref12.locale);
                            relativePath1 = "".concat(localePrefix1).concat(newProductUrl);
                            host2 = (ref13 = context.req) === null || ref13 === void 0 ? void 0 : ref13.headers.host;
                            protocol1 = (host2 === null || host2 === void 0 ? void 0 : host2.includes("localhost")) ? "http" : "https";
                            fullPath1 = "".concat(protocol1, "://").concat(host2).concat(relativePath1);
                            redirectUrl1 = host2 ? fullPath1 : relativePath1;
                            (ref14 = context.res) === null || ref14 === void 0 ? void 0 : ref14.writeHead(301, (_tmp27.Location = redirectUrl1, _tmp27)).end();
                        }
                        _tmp28 = {};
                        // return an object that a non-empty to prevent "returned an empty object" error in logs
                        return [
                            2,
                            (_tmp28.emptyProps = true, _tmp28)
                        ];
                }
            });
        });
        return function(context) {
            return _ref.apply(this, arguments);
        };
    }();
}
/* harmony default export */ var _id_ = (Pdp);


/***/ }),

/***/ 50042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ GWPFreeGiftMessage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24246);
/* harmony import */ var _global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12601);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27378);
/* harmony import */ var ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66224);
/* harmony import */ var hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53625);
/* harmony import */ var hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77480);






var GWPFreeGiftMessage = function(param) {
    var gwpTitle = param.gwpTitle;
    var t = (0,hooks_useTranslations__WEBPACK_IMPORTED_MODULE_5__/* .useTranslate */ .qM)();
    var isGiftWithPurchaseNewDesign = (0,hooks_useFeature__WEBPACK_IMPORTED_MODULE_4__/* .useFeature */ .S)("GIFT_WITH_PURCHASE_NEW_DESIGN");
    if (isGiftWithPurchaseNewDesign && gwpTitle) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        role: "alert",
        className: "flex items-center space-x-2 text-xs text-success-60",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_global_ecom_nitro_uds_elements__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO$, {
                name: "gift",
                size: "2xl"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-bold uppercase text-sm mb-0.5",
                children: gwpTitle
            })
        ]
    });
    if (!isGiftWithPurchaseNewDesign) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ui_elements_AlertMessage__WEBPACK_IMPORTED_MODULE_3__/* .AlertMessage */ .g, {
        type: "success",
        icon: "gift",
        dataTestId: "free-gift-message",
        children: t("freeGiftWithPurchaseItem")
    });
    return null;
};


/***/ }),

/***/ 28477:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fy": function() { return /* reexport safe */ _OldDesign__WEBPACK_IMPORTED_MODULE_1__.f; },
/* harmony export */   "kq": function() { return /* reexport safe */ _NewDesign__WEBPACK_IMPORTED_MODULE_0__.k; }
/* harmony export */ });
/* harmony import */ var _NewDesign__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41347);
/* harmony import */ var _OldDesign__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12656);
/* harmony import */ var _GWP_FreeGiftMessage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50042);





/***/ }),

/***/ 24673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ EmplifiScript; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23842);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59312);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27378);
/* harmony import */ var hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20368);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79758);





var EmplifiScript = function(param) {
    var sku = param.sku, pageId = param.pageId;
    var prevSku = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(sku);
    var ref = (0,hooks_useSiteConfig__WEBPACK_IMPORTED_MODULE_1__/* .useSiteConfig */ .N)(), locale = ref.locale, env = ref.env;
    var emplifiTurnToSite = env.emplifiTurnToSite && JSON.parse(env.emplifiTurnToSite);
    var addEmplifiWidgetWithConfig = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var ref, ref1, idScript1, idScript2, ref2, turnToSiteKey, siteLocale, _tmp, _tmp1;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    idScript1 = "emplifi-and-turnToConfig";
                    idScript2 = "turnTo-widgets-script";
                    (ref = document.getElementById(idScript1)) === null || ref === void 0 ? void 0 : ref.remove();
                    (ref1 = document.getElementById(idScript2)) === null || ref1 === void 0 ? void 0 : ref1.remove();
                    ref2 = getTurnToSiteKeyAndLocale(locale, emplifiTurnToSite), turnToSiteKey = ref2.turnToSiteKey, siteLocale = ref2.siteLocale;
                    _tmp = {};
                    return [
                        4,
                        addScript((_tmp.id = idScript1, _tmp.text = (sku ? 'var turnToConfig = {\n                sku: "'.concat(sku, '",\n                locale: "').concat(siteLocale, '",\n                pageId: "').concat(pageId, '"\n              };\n            ') : 'var turnToConfig = {\n                locale: "'.concat(siteLocale, '",\n                pageId: "').concat(pageId, '"\n              };\n            ')) + "window.TurnToCmd=window.TurnToCmd||function(){(TurnToCmd.q=TurnToCmd.q||[]).push(arguments)};", _tmp))
                    ];
                case 1:
                    _state.sent();
                    _tmp1 = {};
                    return [
                        4,
                        addScript((_tmp1.id = idScript2, _tmp1.url = "https://widgets.turnto.com/v5/widgets/".concat(turnToSiteKey, "/js/turnto.js") + // hack https://stackoverflow.com/questions/9642205/how-to-force-a-script-reload-and-re-execute#comment12241680_9642359
                        "?cachebuster=" + new Date().getTime(), _tmp1))
                    ];
                case 2:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    }), [
        emplifiTurnToSite,
        locale,
        pageId,
        sku
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        addEmplifiWidgetWithConfig();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (prevSku.current !== sku) addEmplifiWidgetWithConfig();
        prevSku.current = sku;
    }, [
        addEmplifiWidgetWithConfig,
        sku
    ]);
    return null;
};
// ── UTILS ONLY FOR THIS FILE ───────────────────────────────────────────────────────────────────────────
var addScript = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(param) {
        var text, url, id;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            text = param.text, url = param.url, id = param.id;
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        var newScript = document.createElement("script");
                        newScript.id = id;
                        if (text) {
                            newScript.text = text;
                            resolve("");
                        }
                        if (url) {
                            newScript.src = url;
                            newScript.addEventListener("load", resolve);
                        }
                        newScript.addEventListener("error", reject);
                        document.body.append(newScript);
                    } catch (e) {
                        reject(e);
                    }
                })
            ];
        });
    });
    return function addScript(_) {
        return _ref.apply(this, arguments);
    };
}();
var getTurnToSiteKeyAndLocale = function(locale, emplifiTurnToSite) {
    switch(locale){
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SUPPORTED_LOCALE.EN_CA */ .xM.EN_CA:
            return {
                turnToSiteKey: emplifiTurnToSite.en_CA.turnToSiteKey,
                siteLocale: emplifiTurnToSite.en_CA.siteLocale
            };
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SUPPORTED_LOCALE.FR_CA */ .xM.FR_CA:
            return {
                turnToSiteKey: emplifiTurnToSite.fr_CA.turnToSiteKey,
                siteLocale: emplifiTurnToSite.fr_CA.siteLocale
            };
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .SUPPORTED_LOCALE.EN_US */ .xM.EN_US:
        default:
            return {
                turnToSiteKey: emplifiTurnToSite.turnToSiteKey,
                siteLocale: emplifiTurnToSite.siteLocale
            };
    }
};


/***/ }),

/***/ 52938:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getContentInputQuery; }
/* harmony export */ });
/* harmony import */ var hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95967);

/**
 *
 * This function generates a formatted input object for content groq queries, including the query string, source, parameters, and preview status.
 *
 */ var getContentInputQuery = function(param) {
    var query = param.query, context = param.context, params = param.params;
    return {
        input: {
            query: query.replace(/[\n]+/g, "").replace(/\s\s+/g, ""),
            src: context.query.src,
            params: params,
            draft: context.query.draft,
            preview: (0,hooks_useGroqQuery__WEBPACK_IMPORTED_MODULE_0__/* .groqPreviewInput */ .i8)(context.query)
        }
    };
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9372,1489,6666,9294,2042,6740,769,4579,1061,5656,2026,6346,9774,2888,179], function() { return __webpack_exec__(51674); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);